import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const ArrowUpIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon height="20" viewBox="2 2 20 20" width="20" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16L11 12L8 12L12 8L16 12L13 12L13 16L11 16Z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
